import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheckIcon, Loader2Icon, XCircleIcon } from "lucide-react";

/* ===== Acesso externo do FORNECEDOR via LINK ÚNICO TOKENIZADO (sem login) ===== */
export default function FornecedorAcesso() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [erro, setErro] = useState("");

  useEffect(() => {
    (async () => {
      try {
        await api.post("/auth/fornecedor-token", { token });
        await refresh();
        navigate("/fornecedor", { replace: true });
      } catch (e) {
        setErro(formatApiError(e.response?.data?.detail) || "Link inválido");
      }
    })();
    // eslint-disable-next-line
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white flex items-center justify-center p-6" data-testid="fornecedor-acesso-page">
      <div className="border border-border bg-[#14151A] p-10 max-w-md w-full text-center space-y-5">
        <div className="w-14 h-14 bg-[#FFD60A] flex items-center justify-center mx-auto">
          <ShieldCheckIcon className="w-8 h-8 text-black" strokeWidth={2.5} />
        </div>
        <div className="font-display text-2xl font-black">PORTAL DO <span className="text-[#FFD60A]">FORNECEDOR</span></div>
        {!erro ? (
          <div className="flex items-center justify-center gap-2 text-sm text-[#00E5FF]" data-testid="acesso-validando">
            <Loader2Icon className="w-4 h-4 animate-spin" /> Validando seu link de acesso...
          </div>
        ) : (
          <div className="space-y-3" data-testid="acesso-erro">
            <div className="flex items-center justify-center gap-2 text-sm text-[#FF3B30]">
              <XCircleIcon className="w-4 h-4" /> {erro}
            </div>
            <div className="text-[11px] text-muted-foreground">Solicite um novo link de acesso ao gestor da base.</div>
          </div>
        )}
      </div>
    </div>
  );
}
